<template>
  <div>
    <h2>{{ $t('views.devices.changetracking.title') }}</h2>

    <entity-changetracking-table :entityBy="eParent" :storeModule="storeModule"/>
  </div>
</template>

<script>
import { STOREMODULE_ENDPOINTMODULE_MAP } from '@/constants'
import MixinEntityBase from '@/components/mixins/EntityBase'
import EntityChangetrackingTable from '@/components/entity/ChangetrackingTable'

export default {
  name: 'Devices.ChangeTracking',
  mixins: [MixinEntityBase],
  components: {
    EntityChangetrackingTable
  },
  data () {
    return {
      storeModule: STOREMODULE_ENDPOINTMODULE_MAP.customer
    }
  }
}
</script>

<style lang="scss"></style>
